import { gql } from '@apollo/client';

export * from './tasks.query.generated';

export const TASKS = gql`
  query tasks(
    $status: TaskStatusEnum
    $eventTypes: [String!]
    $criticality: TaskCriticalityEnum
    $createdAfter: ISO8601Date
    $page: Int
    $perPage: Int
    $appId: ID
  ) {
    tasks(
      status: $status
      eventTypes: $eventTypes
      criticality: $criticality
      createdAfter: $createdAfter
      page: $page
      perPage: $perPage
      appId: $appId
    ) {
      nodes {
        id
        createdAt
        criticality
        eventType
        payload
        parentId
        parentType
        recordId
      }
      hasNextPage
      hasPreviousPage
      nodesCount
      pagesCount
    }
  }
`;
